import dayjs from 'dayjs';
import { isJapaneseLocale } from '@/i18n';

/** JA: YYYY/MM/DD, otherwise: DD/MM/YYYY */
export const formatDisplayDate = (value?: string | number | Date | dayjs.Dayjs | null): string => {
  if (value == null || value === '') {
    return '';
  }
  const date = dayjs(value);
  if (!date.isValid()) {
    return '';
  }
  return isJapaneseLocale()
    ? date.format('YYYY/MM/DD')
    : date.format('DD/MM/YYYY');
};

/** Home section header: JA → YYYY-MM-DD, otherwise → DD/MM/YYYY */
export const formatHomeSectionDate = (value?: string | number | Date | dayjs.Dayjs | null): string => {
  if (value == null || value === '') {
    return '';
  }
  const date = dayjs(value);
  if (!date.isValid()) {
    return '';
  }
  return isJapaneseLocale()
    ? date.format('YYYY-MM-DD')
    : date.format('DD/MM/YYYY');
};

const isPlausibleDayMonth = (day: number, month: number): boolean =>
  month >= 1 && month <= 12 && day >= 1 && day <= 31;

/**
 * Reformat date tokens embedded in chat/feed body text by app locale.
 * JA → YYYY/MM/DD; otherwise → DD/MM/YYYY.
 */
export const localizeDatesInText = (text: string): string => {
  if (!text) {
    return text;
  }
  const toJa = isJapaneseLocale();

  // DD/MM/YYYY or DD-MM-YYYY
  let result = text.replace(
    /(\d{2})([/-])(\d{2})\2(\d{4})/g,
    (match, dd, _sep, mm, yyyy) => {
      const day = Number(dd);
      const month = Number(mm);
      if (!isPlausibleDayMonth(day, month)) {
        return match;
      }
      return toJa ? `${yyyy}/${mm}/${dd}` : `${dd}/${mm}/${yyyy}`;
    },
  );

  // YYYY/MM/DD or YYYY-MM-DD
  result = result.replace(
    /(\d{4})([/-])(\d{2})\2(\d{2})/g,
    (match, yyyy, _sep, mm, dd) => {
      const day = Number(dd);
      const month = Number(mm);
      if (!isPlausibleDayMonth(day, month)) {
        return match;
      }
      return toJa ? `${yyyy}/${mm}/${dd}` : `${dd}/${mm}/${yyyy}`;
    },
  );

  return result;
};
